/*
  Just Tattoos — camera try-on. Plain ES2020, no dependencies (no AR library:
  the live site ships no 3D model, only a transparent overlay PNG), defer.
  Opens a fullscreen modal on user click only, streams the camera with
  getUserMedia({ video: { facingMode } }) and overlays the product's transparent
  design image (custom.ar_overlay_image). Overlay is draggable, pinch/wheel to
  scale, rotate handle, flips, capture to PNG. No permission is requested until
  a Try On control is activated.
  Triggers: [data-try-on] (PDP, has data-overlay-src), [data-ar-try-on] (cards).
*/
(function () {
  'use strict';

  var doc = document;

  var DEFAULTS = {
    title: 'Studio AR',
    back: 'Back',
    switch: 'Switch Camera',
    flip_h: 'Flip H',
    flip_v: 'Flip V',
    reset: 'Reset',
    save: 'Save',
    scale: 'Scale',
    rotation: 'Rotation',
    opacity: 'Opacity',
    blocked_title: 'Camera Access Blocked',
    blocked_text: "To use the Virtual Try-On studio, please click the camera/lock icon in your browser's URL address bar and change the permission toggle to \"Allow\".",
    failed_title: 'Hardware Initialization Failed',
    failed_text: 'Could not secure a video track feed. Please verify your device camera is turned on, unblocked by system privacy hardware toggles, and running through a secure connection (HTTPS).',
    unsupported: 'Camera access requires a secure connection (HTTPS).'
  };

  function strings() {
    var el = doc.querySelector('[data-tryon-strings]');
    var merged = {};
    var key;
    for (key in DEFAULTS) if (Object.prototype.hasOwnProperty.call(DEFAULTS, key)) merged[key] = DEFAULTS[key];
    if (el) {
      try {
        var parsed = JSON.parse(el.textContent);
        for (key in parsed) if (Object.prototype.hasOwnProperty.call(parsed, key) && parsed[key]) merged[key] = parsed[key];
      } catch (err) { /* keep defaults */ }
    }
    return merged;
  }

  var S = strings();
  var modal = null;
  var els = null;
  var stream = null;
  var facing = 'user';
  var lastFocused = null;
  var pointers = new Map();
  var pinch = { startDist: 0, startScale: 1 };
  var drag = { active: false, startX: 0, startY: 0, originX: 0, originY: 0 };
  var rotate = { active: false, startAngle: 0, startRotation: 0 };
  var state = { x: 0, y: 0, scale: 1, rotation: 0, flipX: false, flipY: false, opacity: 0.9 };

  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }

  function stopStream() {
    if (stream) { stream.getTracks().forEach(function (track) { track.stop(); }); stream = null; }
  }

  function applyTransform() {
    if (!els) return;
    var sx = state.scale * (state.flipX ? -1 : 1);
    var sy = state.scale * (state.flipY ? -1 : 1);
    els.wrap.style.transform = 'translate3d(' + state.x + 'px,' + state.y + 'px,0) scale(' + sx + ',' + sy + ') rotate(' + state.rotation + 'deg)';
    els.wrap.style.opacity = String(state.opacity);
    if (els.scale) els.scale.value = String(clamp(state.scale, 0.2, 5));
    if (els.opacity) els.opacity.value = String(clamp(state.opacity, 0.1, 1));
    if (els.rotation) els.rotation.value = String(clamp(state.rotation, -180, 180));
  }

  function resetTransform() {
    state.x = 0; state.y = 0; state.scale = 1; state.rotation = 0; state.flipX = false; state.flipY = false; state.opacity = 0.9;
    applyTransform();
  }

  function buildModal() {
    var wrap = doc.createElement('div');
    wrap.className = 'jt-tryon';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', S.title);
    wrap.innerHTML =
      '<div class="jt-tryon__topbar">' +
        '<button type="button" class="jt-tryon__back" data-tryon-close><span aria-hidden="true">&#8592;</span> <span data-label="back"></span></button>' +
        '<span class="jt-tryon__name" data-label="title"></span>' +
        '<button type="button" class="jt-tryon__icon-btn" data-tryon-flip><span data-label="switch"></span></button>' +
      '</div>' +
      '<div class="jt-tryon__stage" data-tryon-stage>' +
        '<video class="jt-tryon__video" autoplay playsinline muted></video>' +
        '<div class="jt-tryon__overlay-wrap" data-overlay-wrap>' +
          '<img class="jt-tryon__overlay" data-overlay alt="" draggable="false" crossorigin="anonymous">' +
          '<button type="button" class="jt-tryon__rotate-handle" data-rotate-handle aria-label="' + S.rotation + '"></button>' +
        '</div>' +
        '<div class="jt-tryon__message" data-tryon-message hidden>' +
          '<h3 class="jt-tryon__message-title" data-message-title></h3>' +
          '<p class="jt-tryon__message-text" data-message-text></p>' +
        '</div>' +
      '</div>' +
      '<div class="jt-tryon__toolbar">' +
        '<div class="jt-tryon__row">' +
          '<button type="button" class="jt-tryon__tool" data-flip-h><span data-label="flip_h"></span></button>' +
          '<button type="button" class="jt-tryon__tool" data-flip-v><span data-label="flip_v"></span></button>' +
          '<button type="button" class="jt-tryon__tool" data-reset><span data-label="reset"></span></button>' +
        '</div>' +
        '<label class="jt-tryon__field"><span data-label="scale"></span><input type="range" data-scale min="0.2" max="5" step="0.01" value="1"></label>' +
        '<label class="jt-tryon__field"><span data-label="rotation"></span><input type="range" data-rotation min="-180" max="180" step="1" value="0"></label>' +
        '<label class="jt-tryon__field"><span data-label="opacity"></span><input type="range" data-opacity min="0.1" max="1" step="0.01" value="0.9"></label>' +
        '<button type="button" class="jt-tryon__save" data-capture><span data-label="save"></span></button>' +
      '</div>';
    doc.body.appendChild(wrap);
    return wrap;
  }

  function fillLabels() {
    if (!modal) return;
    Array.prototype.slice.call(modal.querySelectorAll('[data-label]')).forEach(function (el) {
      var key = el.getAttribute('data-label');
      if (S[key]) el.textContent = S[key];
    });
  }

  function showMessage(title, text) {
    if (!els || !els.message) return;
    els.message.hidden = false;
    els.message.querySelector('[data-message-title]').textContent = title || '';
    els.message.querySelector('[data-message-text]').textContent = text || '';
  }
  function hideMessage() { if (els && els.message) els.message.hidden = true; }

  function startCamera() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { showMessage('', S.unsupported); return; }
    stopStream();
    navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false })
      .then(function (mediaStream) {
        stream = mediaStream;
        hideMessage();
        if (els && els.video) {
          els.video.srcObject = mediaStream;
          els.video.classList.toggle('is-mirrored', facing === 'user');
          var play = els.video.play();
          if (play && play.catch) play.catch(function () {});
        }
      })
      .catch(function (err) {
        if (err && (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError')) showMessage(S.blocked_title, S.blocked_text);
        else showMessage(S.failed_title, S.failed_text);
      });
  }

  function open(src) {
    if (modal) return;
    lastFocused = doc.activeElement;
    modal = buildModal();
    els = {
      video: modal.querySelector('.jt-tryon__video'),
      wrap: modal.querySelector('[data-overlay-wrap]'),
      overlay: modal.querySelector('[data-overlay]'),
      message: modal.querySelector('[data-tryon-message]'),
      scale: modal.querySelector('[data-scale]'),
      rotation: modal.querySelector('[data-rotation]'),
      opacity: modal.querySelector('[data-opacity]'),
      stage: modal.querySelector('[data-tryon-stage]')
    };
    fillLabels();
    if (els.overlay && src) els.overlay.src = src;
    resetTransform();
    doc.body.classList.add('is-tryon-open');
    startCamera();
    var closeBtn = modal.querySelector('[data-tryon-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!modal) return;
    stopStream();
    if (modal.parentNode) modal.parentNode.removeChild(modal);
    modal = null; els = null; pointers.clear();
    doc.body.classList.remove('is-tryon-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function stepScale(delta) { state.scale = clamp(state.scale + delta, 0.2, 5); applyTransform(); }

  function pointerList() { return Array.prototype.slice.call(pointers.values()); }
  function distance(a, b) { var dx = a.x - b.x; var dy = a.y - b.y; return Math.sqrt(dx * dx + dy * dy); }

  function onPointerDown(event) {
    if (!els) return;
    var handle = event.target.closest('[data-rotate-handle]');
    if (handle) {
      rotate.active = true;
      var rect = els.wrap.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      rotate.startAngle = Math.atan2(event.clientY - cy, event.clientX - cx) * 180 / Math.PI;
      rotate.startRotation = state.rotation;
      handle.setPointerCapture(event.pointerId);
      return;
    }
    if (event.target === els.overlay || event.target === els.wrap) {
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (els.wrap.setPointerCapture) els.wrap.setPointerCapture(event.pointerId);
      if (pointers.size === 1) {
        drag.active = true; drag.startX = event.clientX; drag.startY = event.clientY; drag.originX = state.x; drag.originY = state.y;
      } else if (pointers.size === 2) {
        drag.active = false;
        pinch.startDist = distance(pointerList()[0], pointerList()[1]);
        pinch.startScale = state.scale;
      }
    }
  }

  function onPointerMove(event) {
    if (!els) return;
    if (rotate.active) {
      var rect = els.wrap.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var angle = Math.atan2(event.clientY - cy, event.clientX - cx) * 180 / Math.PI;
      state.rotation = clamp(rotate.startRotation + (angle - rotate.startAngle), -180, 180);
      applyTransform();
      return;
    }
    if (pointers.has(event.pointerId)) pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 2) {
      var dist = distance(pointerList()[0], pointerList()[1]);
      if (pinch.startDist > 0) { state.scale = clamp(pinch.startScale * (dist / pinch.startDist), 0.2, 5); applyTransform(); }
    } else if (drag.active && pointers.size === 1) {
      state.x = drag.originX + (event.clientX - drag.startX);
      state.y = drag.originY + (event.clientY - drag.startY);
      applyTransform();
    }
  }

  function onPointerUp(event) {
    pointers.delete(event.pointerId);
    if (pointers.size === 0) { drag.active = false; rotate.active = false; }
  }

  function capture() {
    if (!els || !els.video) return;
    var video = els.video;
    var width = video.videoWidth || 720;
    var height = video.videoHeight || 1280;
    var canvas = doc.createElement('canvas');
    canvas.width = width; canvas.height = height;
    var ctx = canvas.getContext('2d');
    var stage = els.stage.getBoundingClientRect();
    if (ctx && video.videoWidth) {
      ctx.save();
      if (facing === 'user') { ctx.translate(width, 0); ctx.scale(-1, 1); }
      ctx.drawImage(video, 0, 0, width, height);
      ctx.restore();
      var overlay = els.overlay;
      var ow = overlay.naturalWidth || 350;
      var oh = overlay.naturalHeight || 350;
      var base = Math.min(width, height) * 0.55;
      var ratio = ow / (oh || 1);
      var dw = ratio >= 1 ? base : base * ratio;
      var dh = ratio >= 1 ? base / ratio : base;
      var px = stage.width ? width / stage.width : 1;
      var py = stage.height ? height / stage.height : 1;
      ctx.save();
      ctx.translate(width / 2 + state.x * px, height / 2 + state.y * py);
      ctx.rotate(state.rotation * Math.PI / 180);
      ctx.scale(state.flipX ? -1 : 1, state.flipY ? -1 : 1);
      ctx.globalAlpha = state.opacity;
      ctx.globalCompositeOperation = 'multiply';
      try { ctx.drawImage(overlay, -dw * state.scale / 2, -dh * state.scale / 2, dw * state.scale, dh * state.scale); } catch (err) { /* tainted canvas */ }
      ctx.restore();
    }
    canvas.toBlob(function (blob) {
      if (!blob) return;
      var file = new File([blob], 'tattoo-try-on.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], title: 'My Tattoo Try-On' }).catch(function () { download(blob); });
      } else {
        download(blob);
      }
    }, 'image/png');
  }

  function download(blob) {
    var url = URL.createObjectURL(blob);
    var link = doc.createElement('a');
    link.href = url; link.download = 'tattoo-try-on.png';
    doc.body.appendChild(link); link.click(); doc.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function resolveSrc(button) {
    var src = button.getAttribute('data-overlay-src');
    if (src) return src;
    var card = button.closest('.product-card');
    var img = card && card.querySelector('.product-card__image');
    return img ? (img.currentSrc || img.src) : '';
  }

  doc.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-try-on], [data-ar-try-on]');
    if (!trigger) return;
    event.preventDefault();
    open(resolveSrc(trigger));
  });

  doc.addEventListener('pointerdown', function (event) {
    if (!els) return;
    if (event.target.closest('[data-tryon-close]')) { close(); return; }
    if (event.target.closest('[data-tryon-flip]')) { facing = facing === 'user' ? 'environment' : 'user'; startCamera(); return; }
    if (event.target.closest('[data-flip-h]')) { state.flipX = !state.flipX; applyTransform(); return; }
    if (event.target.closest('[data-flip-v]')) { state.flipY = !state.flipY; applyTransform(); return; }
    if (event.target.closest('[data-reset]')) { resetTransform(); return; }
    if (event.target.closest('[data-capture]')) { capture(); return; }
    if (event.target.closest('[data-tryon-stage]')) onPointerDown(event);
  });
  doc.addEventListener('pointermove', function (event) { if (els) onPointerMove(event); });
  doc.addEventListener('pointerup', onPointerUp);
  doc.addEventListener('pointercancel', onPointerUp);
  doc.addEventListener('input', function (event) {
    if (!els) return;
    if (event.target.matches('[data-scale]')) { state.scale = parseFloat(event.target.value) || 1; applyTransform(); }
    if (event.target.matches('[data-rotation]')) { state.rotation = parseFloat(event.target.value) || 0; applyTransform(); }
    if (event.target.matches('[data-opacity]')) { state.opacity = parseFloat(event.target.value) || 0.9; applyTransform(); }
  });
  doc.addEventListener('wheel', function (event) {
    if (els && event.target.closest('[data-tryon-stage]')) { event.preventDefault(); stepScale(event.deltaY < 0 ? 0.08 : -0.08); }
  }, { passive: false });
  doc.addEventListener('keydown', function (event) { if (event.key === 'Escape' && modal) close(); });

  window.JT = window.JT || {};
  window.JT.tryOn = { open: open, close: close };
})();
